module.exports = __webpack_public_path__ + "img/discounts.99196b22.svg";